export default __webpack_public_path__ + "static/media/UserGuide_CommonMenu.567d79c6.svg";